const linkTitleRequests = new Map<string, Promise<string>>()

export const fetchLinkTitle = (url: string) => {
  const cachedRequest = linkTitleRequests.get(url)

  if (cachedRequest) {
    return cachedRequest
  }

  const request = fetch('https://d5d12ptu7p2h9rcot54m.apigw.yandexcloud.net/', {
    body: JSON.stringify({ url }),
    method: 'POST',
  })
    .then<{
      title?: string
    }>((res) => res.json())
    .then((res) => {
      return typeof res?.title === 'string' ? res.title : ''
    })
    .catch((error) => {
      linkTitleRequests.delete(url)
      console.error(error)

      return ''
    })

  linkTitleRequests.set(url, request)

  return request
}
